import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { allCarrerasAction } from '../../../sistema/carreras/CarrerasAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEntVistasAction,
  deleteEntVistasAction,
  setActivoEntVistasAction,
} from '../EntVistasAction';
import { PARAMS_ENT_VISTAS } from '../EntVistasReducer';

const ListadoEntVistas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const carrerasStore = Redux.useSelector((state) => state.carreras);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entVistasStore = Redux.useSelector((state) => state.entVistas);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (carrerasStore.all && carrerasStore.all.length === 0) {
        await allCarrerasAction(dispatch, null);
      }
      const payload = {
        ...entVistasStore.params,
        idEntidad: entidadesStore.activo.id,
      };
      dispatch({ type: PARAMS_ENT_VISTAS, payload });
      if (entVistasStore.all && entVistasStore.all.length === 0) {
        allEntVistasAction({ dispatch }, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = entVistasStore.all.find((el) => el.id === id);
    await setActivoEntVistasAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteEntVistasAction(
      { dispatch, notify },
      entVistasStore.activo.id,
      entVistasStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.vista.name,
      label: CONST.vista.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.nombre}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.isInicio.name,
      label: CONST.isInicio.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
              label={value ? 'SI' : 'NO'}
              size="small"
              color={value ? 'success' : 'error'}
            />
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value.nombre}
                size="small"
                color={value.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = entVistasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoEntVistasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <LoadingWidget isLoading={entVistasStore.loadingAll || loadingDelete} />
      <Grid item md={12}>
        <MUIDataTable
          title={'Listado'}
          data={entVistasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {entVistasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{entVistasStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEntVistas;
